import { uploadFile } from '@widgets/UserManagementTable/api';
import { Api } from '../../Api';
import { ListResult } from '../../interfaces';
import { UserCreationBody, UserManagementBody } from './body';

export class UserManagement {
    private static _basePath = '/User';

    public static getMethods(parentPath: string) {
        const basePath = `${parentPath}${UserManagement._basePath}`;
        return {
            async get(query: any) {
                const path = '/';
                let results = await Api.get<ListResult<UserManagementBody>>({
                    path: `${basePath}${path}`,
                    query,
                });

                if (results) {
                    results.items?.forEach((element) => {
                        if (element.permissions.some((permission) => permission.name === 'CanLogin')) {
                            element.canLogin = true;
                        }
                        if (element.permissions.some((permission) => permission.name === 'CanSeePositions')) {
                            element.canSeePositions = true;
                        }
                        if (element.permissions.some((permission) => permission.name === 'CanSee1099')) {
                            element.canSee1099 = true;
                        }
                    });
                }
                return results;
            },

            async getbyFdid(fdid: string) {
                const path = '/getByFdid';
                return await Api.get<UserManagementBody>({
                    path: `${basePath}${path}`,
                    query: {
                        fdid: fdid,
                    },
                });
            },

            async getByUsername(userName: string) {
                const path = '/getByUsername';
                return await Api.get<any>({
                    path: `${basePath}${path}`,
                    query: {
                        userName: userName,
                    },
                });
            },

            async addUser(body: UserCreationBody) {
                const path = '/';
                return await Api.post<string>({
                    path: `${basePath}${path}`,
                    body,
                });
            },

            async putUser(body: UserManagementBody) {
                const path = '/';
                return await Api.put<string>({
                    path: `${basePath}${path}`,
                    body,
                });
            },

            async assignSubAccounts(body: any, accountId: number) {
                const path = '/assignSubAccounts';
                return await Api.put<string>({
                    path: `${basePath}${path}`,
                    body: { AccountDtos: body, ParentAccountId: accountId },
                });
            },

            async deleteUser(id: number) {
                const path = '/';
                return await Api.delete<string>({
                    path: `${basePath}${path}`,
                    query: {
                        Id: id,
                    },
                });
            },

            async uploadFile(fdId: string, file: File) {
                const formData = new FormData();
                formData.append('file', file);

                return await Api.post<string>({
                    path: `${basePath}/upload?fdid=${fdId}`,
                    body: formData,
                    headers: {
                        'Content-Type': 'multipart/form-data',
                    },
                });
            },
        };
    }
}
